//#region src/Logger.ts
const LOG_LEVELS = [
	"info",
	"log",
	"warn",
	"error"
];
var ConsoleLogger = class ConsoleLogger {
	prefix;
	minLevel;
	constructor(names = [], minLevel = "log") {
		this.names = names;
		this.prefix = names.map((name) => `(${name})`).join(" ");
		this.minLevel = minLevel;
	}
	shouldLog(level) {
		return LOG_LEVELS.indexOf(level) >= LOG_LEVELS.indexOf(this.minLevel);
	}
	log(message, ...args) {
		if (this.shouldLog("log")) console.log(this.prefix, message, ...args);
	}
	error(message, ...args) {
		if (this.shouldLog("error")) console.error(this.prefix, message, ...args);
	}
	warn(message, ...args) {
		if (this.shouldLog("warn")) console.warn(this.prefix, message, ...args);
	}
	info(message, ...args) {
		if (this.shouldLog("info")) console.info(this.prefix, message, ...args);
	}
	scope(name) {
		return new ConsoleLogger([...this.names, name], this.minLevel);
	}
};
const rootLogger = new ConsoleLogger();

//#endregion
export { ConsoleLogger, rootLogger };